import { api } from '@/lib/api'
import type { CreateDocumentTypeRequest, DocumentType, UpdateDocumentTypeRequest } from './types'

const base = (configurationCode: string) => `/api/configurations/${configurationCode}/document-types`

export async function listDocumentTypes(configurationCode: string, activeOnly = false): Promise<DocumentType[]> {
  const r = await api.get<DocumentType[]>(base(configurationCode), { params: { activeOnly } })
  return r.data
}

export async function createDocumentType(configurationCode: string, payload: CreateDocumentTypeRequest): Promise<DocumentType> {
  const r = await api.post<DocumentType>(base(configurationCode), payload)
  return r.data
}

export async function updateDocumentType(configurationCode: string, id: number, payload: UpdateDocumentTypeRequest): Promise<DocumentType> {
  const r = await api.put<DocumentType>(`${base(configurationCode)}/${id}`, payload)
  return r.data
}

export async function deleteDocumentType(configurationCode: string, id: number): Promise<void> {
  await api.delete(`${base(configurationCode)}/${id}`)
}

export async function reorderDocumentTypes(configurationCode: string, ids: number[]): Promise<void> {
  await api.put(`${base(configurationCode)}/order`, { ids })
}
